import { useId } from 'react'
import { DatePicker, Field } from 'admination-react'
import type { FieldHint } from './FormRenderer'

export function DateField({
  label,
  isoValue,
  onChange,
  invalid = false,
  errorMessage,
  hint,
  pastYears = 0,
  required = false,
  minIso,
  maxIso,
}: {
  label: string
  isoValue: string
  onChange: (iso: string) => void
  invalid?: boolean
  errorMessage?: string
  hint?: FieldHint
  pastYears?: number
  required?: boolean
  minIso?: string
  maxIso?: string
}) {
  const id = useId()
  return (
    <Field
      label={label}
      htmlFor={id}
      required={required}
      error={errorMessage}
      hint={hint?.text}
      hintTone={hint?.tone}
    >
      <DatePicker
        id={id}
        value={isoValue}
        onChange={onChange}
        min={minIso}
        max={maxIso}
        pastYears={pastYears}
        prevMonthLabel="Vorheriger Monat"
        nextMonthLabel="Nächster Monat"
        aria-invalid={invalid || undefined}
        aria-required={required || undefined}
      />
    </Field>
  )
}
